import { render, staticRenderFns } from "./Asd.vue?vue&type=template&id=9e8c074c&scoped=true&"
import script from "./Asd.vue?vue&type=script&lang=js&"
export * from "./Asd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8c074c",
  null
  
)

export default component.exports